// dependencies
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// components
import Cell from "./Cell";

// utils
import get from "../../../utils/GetNested";

// style
import css from "../Table.module.scss";

const Row = (props) => {
	const {
		row,
		columns,
		colWidths,
		subheaders = {},
		subheaderColWidths = "",
		cellClassName = null,
		currentScreenWidth,
		hoverRowURL = "",
		clientHeight = null,
		columnRefWidths,
		rowClassName,
		last = false,
	} = props;
	const keys = Object.keys(subheaders);

	const [hovering, setHovering] = useState(false);

	const navigate = useNavigate();

	const alignColumns = () =>
		columns.map((column, index) => {
			// get the field name
			const field = get(column, "id");

			// hide column value
			const mobileViewHideColumn = get(column, "mobileViewHideColumn", false);

			// get the getter, if it exists
			const getter = get(column, "getter", null);

			// get the value
			const value = getter ? getter(row, columnRefWidths[index]) : get(row, field, "");

			// render
			return (
				<Cell
					testId={`tableCell-${field}`}
					className={`${cellClassName || ""} ${
						mobileViewHideColumn > currentScreenWidth ? css.hiddenColumn : ""
					}`}
					key={field}
				>
					{value}
				</Cell>
			);
		});
	const alignSubheaders = () =>
		keys.map((key, index) => {
			const subheaderGroup = subheaders[key];
			return subheaderGroup.map((subheader) => {
				const field = get(subheader, "id");
				const getter = get(subheader, "getter", null);
				const value = getter ? getter(row, columnRefWidths[index]) : get(row, field, "");
				const mobileViewHideColumn = get(subheader, "mobileViewHideColumn", false);
				return (
					<Cell
						className={`${css.subheaderCell} ${
							mobileViewHideColumn > currentScreenWidth ? css.hiddenColumn : ""
						}`}
						key={field}
						testId={`tableSubheaderCell-${field}`}
					>
						{value}
					</Cell>
				);
			});
		});

	const handleClickRow = () => {
		if (hoverRowURL) {
			navigate(hoverRowURL);
		}
	};

	return (
		<div
			data-testid="tableRow"
			className={` ${rowClassName} ${css.row} ${last && css.last} ${hoverRowURL && hovering && css.hoverRow} ${
				clientHeight && css.isStickyRow
			} ${rowClassName || ""}`}
			onMouseEnter={() => setHovering(true)}
			onMouseLeave={() => setHovering(false)}
			onClick={handleClickRow}
			style={clientHeight ? { height: clientHeight } : null}
		>
			<div
				className={css.rowContent}
				style={keys.length ? { gridTemplateColumns: subheaderColWidths } : { gridTemplateColumns: colWidths }}
			>
				{keys.length ? alignSubheaders() : alignColumns()}
			</div>
		</div>
	);
};

Row.propTypes = {
	cellClassName: PropTypes.string,
	subheaders: PropTypes.object,
	subheaderColWidths: PropTypes.string,
	bodyCellClass: PropTypes.string,
	columns: PropTypes.array.isRequired,
	row: PropTypes.object.isRequired,
	colWidths: PropTypes.string.isRequired,
	currentScreenWidth: PropTypes.number.isRequired,
	hoverRowURL: PropTypes.string,
	highlightColumn: PropTypes.string,
	defaultCellClassName: PropTypes.string,
	clientHeight: PropTypes.number,
	columnRefWidths: PropTypes.array,
	last: PropTypes.bool,
	rowClassName: PropTypes.string,
};

export default Row;
